"use strict";

var _require = require('date-fns/index'),
  format = _require.format,
  parseISO = _require.parseISO;
function helper(Handlebars) {
  /**
   * Formats the date in the format provided (Default format - YYYY-MM-DD)
   *
   * @param date
   * @param options
   * @returns {*}
   */
  function dateFormat(d, options) {
    var date;
    if (d === 'now') {
      date = new Date();
    } else {
      date = typeof d === 'string' ? parseISO(d) : d;
    }
    if (date || date === 0) {
      var dFormat = options.hash.format || 'yyyy-MM-dd';
      if (dFormat.match(/Do|YYYY/g)) {
        dFormat = dFormat.replace(/Do/g, 'do');
        dFormat = dFormat.replace(/YYYY/g, 'yyyy');
      }
      return format(date, dFormat);
    }
    return '';
  }
  Handlebars.registerHelper('dateFormat', dateFormat);
  return dateFormat;
}
module.exports = helper;
